// navConfig.js
export const NAV_ITEMS = [
  { keyName: 'nav.about', to: 'about', isExternal: false },
  { keyName: 'nav.treatments', to: 'treatments', isExternal: false },
  { keyName: 'nav.contact', to: 'contact', isExternal: false },
  { keyName: 'nav.faq', to: 'faq', isExternal: false },
];
